const T = window.lpTheme || { routes: {}, strings: {} };
const $ = (sel, root = document) => root.querySelector(sel);
const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])';

/* ---------- drawers (menu + cart) ---------- */
let lastTrigger = null;
function openDrawer(drawer, trigger) {
  if (!drawer) return;
  lastTrigger = trigger || document.activeElement;
  drawer.classList.add('is-open');
  document.documentElement.classList.add('lp-lock');
  $$(`[aria-controls="${drawer.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
  const first = $$(FOCUSABLE, $('.lp-drawer__panel', drawer))[0];
  if (first) setTimeout(() => first.focus(), 50);
}
function closeDrawer(drawer) {
  if (!drawer || !drawer.classList.contains('is-open')) return;
  drawer.classList.remove('is-open');
  if (!$('.lp-drawer.is-open')) document.documentElement.classList.remove('lp-lock');
  $$(`[aria-controls="${drawer.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
  if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
}
document.addEventListener('click', (e) => {
  const opener = e.target.closest('[data-lp-open]');
  if (opener) { e.preventDefault(); openDrawer(document.getElementById(opener.dataset.lpOpen), opener); return; }
  const closer = e.target.closest('[data-lp-close]');
  if (closer) { closeDrawer(closer.closest('[data-lp-drawer]')); return; }
  const cartOpen = e.target.closest('[data-lp-cart-open]');
  if (cartOpen && $('[data-lp-cart]')) { e.preventDefault(); openDrawer($('[data-lp-cart]'), cartOpen); return; }
  const toggle = e.target.closest('[data-lp-toggle]');
  if (toggle) {
    const target = document.getElementById(toggle.dataset.lpToggle);
    if (!target) return;
    const open = target.hidden;
    target.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    if (open) { const f = $(FOCUSABLE, target); if (f) f.focus(); }
  }
});
document.addEventListener('keydown', (e) => {
  const drawer = $('.lp-drawer.is-open');
  if (!drawer) return;
  if (e.key === 'Escape') { closeDrawer(drawer); return; }
  if (e.key === 'Tab') {
    const items = $$(FOCUSABLE, $('.lp-drawer__panel', drawer)).filter((el) => el.offsetParent !== null);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
});

/* ---------- header scroll state ---------- */
const hdr = $('[data-lp-header]');
if (hdr) {
  const onScroll = () => hdr.classList.toggle('is-scrolled', window.scrollY > 8);
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
}

/* ---------- announcement rotation ---------- */
function initRotate(bar) {
  const msgs = $$('.lp-ann__msg', bar);
  if (msgs.length < 2 || reduceMotion) return;
  let i = 0;
  let timer = null;
  const tick = () => { msgs[i].classList.remove('is-active'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-active'); };
  const start = () => { if (!timer) timer = setInterval(tick, Number(bar.dataset.lpRotate) || 5000); };
  const stop = () => { clearInterval(timer); timer = null; };
  bar.addEventListener('mouseenter', stop);
  bar.addEventListener('mouseleave', start);
  bar.addEventListener('focusin', stop);
  bar.addEventListener('focusout', start);
  start();
}

/* ---------- accordions ---------- */
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-lp-acc]');
  if (!btn) return;
  const panel = document.getElementById(btn.getAttribute('aria-controls'));
  if (!panel) return;
  const open = btn.getAttribute('aria-expanded') !== 'true';
  const group = btn.closest('[data-lp-acc-single]');
  if (group && open) {
    $$('[data-lp-acc][aria-expanded="true"]', group).forEach((other) => {
      other.setAttribute('aria-expanded', 'false');
      const op = document.getElementById(other.getAttribute('aria-controls'));
      if (op) op.hidden = true;
    });
  }
  btn.setAttribute('aria-expanded', String(open));
  panel.hidden = !open;
});

/* ---------- media: autoplay videos + external facades ---------- */
function initVideos(scope) {
  const vids = $$('video[data-lp-autoplay]', scope);
  if (!vids.length) return;
  if (reduceMotion) {
    vids.forEach((v) => { v.removeAttribute('autoplay'); v.controls = true; });
  } else if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        const v = en.target;
        if (en.isIntersecting) { v.muted = true; const pr = v.play(); if (pr) pr.catch(() => { v.controls = true; }); }
        else v.pause();
      });
    }, { threshold: 0.25 });
    vids.forEach((v) => io.observe(v));
  }
}
document.addEventListener('click', (e) => {
  const f = e.target.closest('[data-lp-embed]');
  if (!f) return;
  const iframe = document.createElement('iframe');
  iframe.src = f.dataset.lpEmbed;
  iframe.title = f.getAttribute('aria-label') || '';
  iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
  iframe.allowFullscreen = true;
  f.replaceWith(iframe);
  iframe.focus();
});

/* ---------- carousels (generic) ---------- */
function initCarousel(wrap) {
  const track = $('[data-lp-track]', wrap);
  if (!track) return;
  const step = () => (track.firstElementChild ? track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth);
  const prev = $('[data-lp-prev]', wrap);
  const next = $('[data-lp-next]', wrap);
  const dots = $$('[data-lp-dot]', wrap);
  if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
  if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
  dots.forEach((d, i) => d.addEventListener('click', () => track.scrollTo({ left: step() * i, behavior: reduceMotion ? 'auto' : 'smooth' })));
  const sync = () => {
    const idx = Math.round(track.scrollLeft / Math.max(1, step()));
    dots.forEach((d, i) => d.setAttribute('aria-current', String(i === idx)));
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  };
  track.addEventListener('scroll', () => window.requestAnimationFrame(sync), { passive: true });
  sync();
}

/* ---------- countdowns ---------- */
function initCountdown(el) {
  const end = Date.parse(el.dataset.lpCountdown);
  const out = $('[data-lp-cd-out]', el);
  if (Number.isNaN(end) || end <= Date.now()) { el.hidden = true; return; }
  el.hidden = false;
  const pad = (n) => String(n).padStart(2, '0');
  const tick = () => {
    let ms = end - Date.now();
    if (ms <= 0) { el.hidden = true; clearInterval(t); return; }
    const d = Math.floor(ms / 86400000); ms -= d * 86400000;
    const h = Math.floor(ms / 3600000); ms -= h * 3600000;
    const m = Math.floor(ms / 60000); ms -= m * 60000;
    const s = Math.floor(ms / 1000);
    out.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
  };
  tick();
  const t = setInterval(tick, 1000);
}

/* ---------- localization autosubmit ---------- */
document.addEventListener('change', (e) => {
  const sel = e.target.closest('[data-lp-autosubmit]');
  if (sel && sel.form) sel.form.submit();
});

/* ---------- cart ---------- */
const cartEl = () => $('[data-lp-cart]');
function updateCount(count) {
  $$('[data-lp-cart-count]').forEach((b) => { b.textContent = count; b.hidden = Number(count) === 0; });
  $$('[data-lp-cart-label]').forEach((a) => a.setAttribute('aria-label', a.dataset.lpCartLabel.replace('[count]', count)));
}
function renderCart(html) {
  const drawer = cartEl();
  if (!drawer || !html) return;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const fresh = $('[data-lp-cart-inner]', doc);
  const cur = $('[data-lp-cart-inner]', drawer);
  if (fresh && cur) cur.replaceWith(fresh);
}
async function refreshCount() {
  try {
    const r = await fetch(T.routes.cart, { headers: { Accept: 'application/json' } });
    const c = await r.json();
    updateCount(c.item_count);
  } catch (err) { /* network failure: badge keeps last known value */ }
}
async function cartPost(url, body) {
  const drawer = cartEl();
  if (drawer) body.sections = [drawer.dataset.sectionId];
  const res = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  const data = await res.json();
  if (!res.ok || data.status) {
    const msg = data.description || data.message || T.strings.error;
    throw new Error(msg);
  }
  if (drawer && data.sections) renderCart(data.sections[drawer.dataset.sectionId]);
  await refreshCount();
  return data;
}
function cartMsg(text) { const m = $('[data-lp-cart-msg]'); if (m) m.textContent = text || ''; }
document.addEventListener('click', async (e) => {
  const q = e.target.closest('[data-lp-qty]');
  if (q && q.closest('[data-lp-cart]')) {
    q.disabled = true;
    try { await cartPost(T.routes.cartChange, { line: Number(q.dataset.lpQty), quantity: Number(q.dataset.qty) }); }
    catch (err) { cartMsg(err.message); q.disabled = false; }
    return;
  }
  const add = e.target.closest('[data-lp-add]');
  if (add) {
    add.classList.add('is-loading');
    try { await cartPost(T.routes.cartAdd, { items: [{ id: Number(add.dataset.lpAdd), quantity: 1 }] }); }
    catch (err) { cartMsg(err.message); }
    add.classList.remove('is-loading');
    return;
  }
  const disc = e.target.closest('[data-lp-disc-apply]');
  if (disc) {
    const input = $('[data-lp-disc-input]');
    const code = input ? input.value.trim() : '';
    if (!code) return;
    try { await cartPost(T.routes.cartUpdate, { discount: code }); }
    catch (err) { cartMsg(err.message); }
  }
});
document.addEventListener('change', async (e) => {
  const inp = e.target.closest('[data-lp-qty-input]');
  if (inp) {
    try { await cartPost(T.routes.cartChange, { line: Number(inp.dataset.lpQtyInput), quantity: Math.max(0, parseInt(inp.value, 10) || 0) }); }
    catch (err) { cartMsg(err.message); }
    return;
  }
  const note = e.target.closest('[data-lp-note]');
  if (note) {
    fetch(T.routes.cartUpdate, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
  }
});

/* ---------- product buybox ---------- */
function initBuybox(root) {
  const dataEl = $('[data-lp-product-data]', root);
  if (!dataEl) return;
  const data = JSON.parse(dataEl.textContent);
  const form = $('[data-lp-product-form]', root);
  const idField = $('[data-lp-variant-id]', root);
  const qtyField = $('[data-lp-qty-field]', root);
  const atc = $('[data-lp-atc]', root);
  const atcLabel = $('[data-lp-atc-label]', root);
  const msg = $('[data-lp-form-msg]', root);
  const track = $('[data-lp-track]', root);
  const slides = track ? $$('.lp-gal__slide', track) : [];
  const thumbs = $$('[data-lp-thumb]', root);
  let variant = data.variants.find((v) => idField && String(v.id) === idField.value) || data.variants[0];
  let tierIndex = -1;
  const tierInputs = $$('[data-lp-tier]', root);
  const checkedTier = tierInputs.find((t) => t.checked);
  if (checkedTier) tierIndex = Number(checkedTier.dataset.lpTier);
  let qty = qtyField ? Number(qtyField.value) || 1 : 1;

  /* gallery */
  const goTo = (i, smooth = true) => {
    if (!track || !slides[i]) return;
    track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
  };
  const current = () => (track ? Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) : 0);
  if (track) {
    const startIdx = slides.findIndex((s) => Number(s.dataset.mediaId) === variant.media);
    if (startIdx > 0) goTo(startIdx, false);
    track.addEventListener('scroll', () => window.requestAnimationFrame(() => {
      const c = current();
      thumbs.forEach((t, i) => t.setAttribute('aria-current', String(i === c)));
    }), { passive: true });
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(Math.min(slides.length - 1, current() + 1)); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(Math.max(0, current() - 1)); }
    });
  }
  const prev = $('[data-lp-gal-prev]', root);
  const next = $('[data-lp-gal-next]', root);
  if (prev) prev.addEventListener('click', () => goTo((current() - 1 + slides.length) % slides.length));
  if (next) next.addEventListener('click', () => goTo((current() + 1) % slides.length));
  thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.lpThumb))));

  /* lightbox */
  const lb = $('[data-lp-lightbox]', root);
  if (lb) {
    const stage = $('[data-lp-lightbox-stage]', lb);
    let lbIndex = 0;
    const show = (i) => {
      lbIndex = (i + slides.length) % slides.length;
      const src = $('img', slides[lbIndex]);
      stage.innerHTML = '';
      if (src) {
        const clone = src.cloneNode(true);
        clone.className = 'lp-lightbox__img';
        clone.loading = 'eager';
        clone.sizes = '100vw';
        stage.appendChild(clone);
      }
    };
    $$('[data-lp-zoom]', root).forEach((z) => z.addEventListener('click', () => { show(Number(z.dataset.lpZoom)); lb.showModal(); }));
    $('[data-lp-lb-close]', lb).addEventListener('click', () => lb.close());
    const lp = $('[data-lp-lb-prev]', lb);
    const ln = $('[data-lp-lb-next]', lb);
    if (lp) lp.addEventListener('click', () => show(lbIndex - 1));
    if (ln) ln.addEventListener('click', () => show(lbIndex + 1));
    lb.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') show(lbIndex + 1); if (e.key === 'ArrowLeft') show(lbIndex - 1); });
    lb.addEventListener('close', () => goTo(lbIndex, false));
  }

  /* price + button */
  const totalFor = () => {
    if (tierIndex >= 0 && variant.totals[tierIndex]) return variant.totals[tierIndex].pay;
    return variant.qtyTotals[String(qty)] || variant.single;
  };
  const render = () => {
    if (idField) idField.value = variant.id;
    if (qtyField) qtyField.value = qty;
    const now = $('[data-lp-price-now]', root);
    const was = $('[data-lp-price-was]', root);
    const save = $('[data-lp-price-save]', root);
    const unit = $('[data-lp-price-unit]', root);
    if (now) now.textContent = variant.price;
    if (was) { was.hidden = !variant.compare; if (variant.compare) was.lastChild.textContent = variant.compare; }
    if (save) { save.hidden = !variant.save; save.textContent = save.dataset.label.replace('[pct]', variant.save); }
    if (unit) { unit.hidden = !variant.unit; unit.textContent = variant.unit; }
    const tiersEl = $('[data-lp-tiers]', root);
    $$('.lp-tier', root).forEach((tierEl, i) => {
      const tt = variant.totals[i];
      if (!tt) return;
      const tot = $('[data-lp-tier-total]', tierEl);
      const w = $('[data-lp-tier-was]', tierEl);
      const each = $('[data-lp-tier-each]', tierEl);
      if (tot) tot.textContent = tt.pay;
      if (w) w.textContent = tt.base;
      if (each && tiersEl) each.textContent = tiersEl.dataset.eachLabel.replace('[price]', tt.each);
    });
    if (atc) {
      atc.disabled = !variant.available;
      if (atcLabel) atcLabel.textContent = variant.available ? T.strings.addToCart + (atc.dataset.showTotal === 'true' ? ' · ' + totalFor() : '') : T.strings.soldOut;
    }
    const stock = $('[data-lp-stock]', root);
    if (stock) {
      const low = stock.dataset.showLow === 'true' && typeof variant.inv === 'number' && variant.inv > 0 && variant.inv <= Number(stock.dataset.threshold);
      stock.classList.toggle('is-low', low);
      stock.textContent = !variant.available ? T.strings.soldOut : low ? T.strings.lowStock.replace('[count]', variant.inv) : T.strings.inStock;
    }
    document.dispatchEvent(new CustomEvent('lp:variant', { detail: { root, variant, total: totalFor() } }));
  };

  /* variant selection */
  const picker = $('[data-lp-variant-picker]', root);
  const markAvailability = () => {
    if (!picker) return;
    const sel = selectedOptions();
    $$('input[data-lp-option]', picker).forEach((inp) => {
      const pos = Number(inp.dataset.lpOption);
      const test = sel.slice();
      test[pos] = inp.value;
      const match = data.variants.find((v) => v.options.every((o, i) => o === test[i]));
      inp.classList.toggle('is-unavailable', !match || !match.available);
    });
  };
  const selectedOptions = () => data.options.map((_, i) => {
    const r = $(`input[data-lp-option="${i}"]:checked`, picker);
    if (r) return r.value;
    const s = $(`select[data-lp-option="${i}"]`, picker);
    return s ? s.value : null;
  });
  if (picker) {
    picker.addEventListener('change', () => {
      const sel = selectedOptions();
      sel.forEach((v, i) => { const l = $(`[data-lp-option-label="${i}"]`, picker); if (l) l.textContent = v; });
      const match = data.variants.find((v) => v.options.every((o, i) => o === sel[i]));
      if (!match) {
        if (atc) { atc.disabled = true; if (atcLabel) atcLabel.textContent = T.strings.unavailable; }
        return;
      }
      variant = match;
      if (variant.media) {
        const idx = slides.findIndex((s) => Number(s.dataset.mediaId) === variant.media);
        if (idx >= 0) goTo(idx);
      }
      if (root.dataset.updateUrl === 'true') {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      markAvailability();
      render();
    });
    markAvailability();
  }
  tierInputs.forEach((t) => t.addEventListener('change', () => {
    tierIndex = Number(t.dataset.lpTier);
    qty = Number(t.dataset.qty) || 1;
    render();
  }));
  const qInput = $('[data-lp-qty-input-main]', root);
  if (qInput) {
    const setQ = (n) => { qty = Math.max(1, Math.min(99, n || 1)); qInput.value = qty; render(); };
    $$('[data-lp-step]', root).forEach((b) => b.addEventListener('click', () => setQ(qty + Number(b.dataset.lpStep))));
    qInput.addEventListener('change', () => setQ(parseInt(qInput.value, 10)));
  }

  /* add to cart */
  if (form) {
    form.addEventListener('submit', async (e) => {
      if (!cartEl()) return;
      e.preventDefault();
      if (!variant.available) return;
      if (msg) msg.textContent = '';
      atc.classList.add('is-loading');
      atc.setAttribute('aria-busy', 'true');
      try {
        await cartPost(T.routes.cartAdd, { items: [{ id: variant.id, quantity: qty }] });
        openDrawer(cartEl(), atc);
      } catch (err) {
        if (msg) msg.textContent = err.message || T.strings.error;
      }
      atc.classList.remove('is-loading');
      atc.removeAttribute('aria-busy');
    });
  }
  render();
}

/* ---------- sticky add to cart ---------- */
function initSticky() {
  const satc = $('[data-lp-satc]');
  if (!satc) return;
  const bb = $('[data-lp-buybox]');
  const mainBtn = bb ? $('[data-lp-atc]', bb) : null;
  const btn = $('[data-lp-satc-btn]', satc);
  if (!bb || !mainBtn) {
    satc.remove();
  } else {
    const setVisible = (on) => {
      satc.classList.toggle('is-visible', on);
      satc.setAttribute('aria-hidden', String(!on));
      satc.inert = !on;
    };
    const io = new IntersectionObserver(([en]) => {
      const past = !en.isIntersecting && en.boundingClientRect.top < 0;
      setVisible(past);
    });
    io.observe(mainBtn);
    btn.addEventListener('click', () => {
      const form = mainBtn.form;
      if (form && typeof form.requestSubmit === 'function') form.requestSubmit(mainBtn);
      else mainBtn.click();
    });
    document.addEventListener('lp:variant', (e) => {
      if (e.detail.root !== bb) return;
      const v = e.detail.variant;
      const price = $('[data-lp-satc-price]', satc);
      if (price) price.textContent = e.detail.total;
      const vt = $('[data-lp-satc-variant]', satc);
      if (vt && vt.firstChild && vt.firstChild.nodeType === 3 && v.title !== 'Default Title') vt.firstChild.textContent = v.title + ' · ';
      btn.disabled = !v.available;
    });
  }
}

/* ---------- newsletter (inline validation only; submission is Shopify's customer form) ---------- */
document.addEventListener('submit', (e) => {
  const form = e.target.closest('form[id^="lp-ft-nl"], form[id^="lp-nl"]');
  if (!form) return;
  const email = form.querySelector('input[type=email]');
  if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim())) {
    e.preventDefault();
    email.setAttribute('aria-invalid', 'true');
    const out = form.querySelector('[role=status]');
    if (out) out.textContent = T.strings.newsletterInvalid;
    email.focus();
  }
});

/* ---------- boot ---------- */
function initAll(scope = document) {
  $$('[data-lp-rotate]', scope).forEach(initRotate);
  $$('[data-lp-carousel]', scope).forEach(initCarousel);
  $$('[data-lp-countdown]', scope).forEach(initCountdown);
  $$('[data-lp-buybox]', scope).forEach(initBuybox);
  initVideos(scope);
}
initAll();
initSticky();

/* ---------- theme editor ---------- */
document.addEventListener('shopify:section:load', (e) => { initAll(e.target); initSticky(); });
document.addEventListener('shopify:block:select', (e) => {
  const drawer = e.target.closest('[data-lp-drawer]');
  if (drawer) openDrawer(drawer);
});

/* ---------- tabs ---------- */
document.addEventListener('click', (e) => {
  const tab = e.target.closest('[role="tab"]');
  if (!tab || !tab.closest('[data-lp-tabs]')) return;
  selectTab(tab);
});
document.addEventListener('keydown', (e) => {
  const tab = e.target.closest('[role="tab"]');
  if (!tab || !tab.closest('[data-lp-tabs]') || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
  const tabs = $$('[role="tab"]', tab.parentElement);
  let i = tabs.indexOf(tab);
  if (e.key === 'ArrowRight') i = (i + 1) % tabs.length;
  if (e.key === 'ArrowLeft') i = (i - 1 + tabs.length) % tabs.length;
  if (e.key === 'Home') i = 0;
  if (e.key === 'End') i = tabs.length - 1;
  e.preventDefault();
  selectTab(tabs[i]);
  tabs[i].focus();
});
function selectTab(tab) {
  $$('[role="tab"]', tab.parentElement).forEach((t) => {
    const on = t === tab;
    t.setAttribute('aria-selected', String(on));
    t.tabIndex = on ? 0 : -1;
    const panel = document.getElementById(t.getAttribute('aria-controls'));
    if (panel) panel.hidden = !on;
  });
}

/* ---------- review wall: filters + load more ---------- */
function initReviewWall(root) {
  const cards = $$('.lp-rw__card', root);
  const more = $('[data-lp-rw-more]', root);
  const initial = Number(root.dataset.initial) || 6;
  let limit = initial;
  let filter = 'all';
  const apply = () => {
    const matches = cards.filter((c) => filter === 'all' || (filter === 'photo' && c.dataset.photo === '1') || (filter === 'five' && c.dataset.stars === '5'));
    cards.forEach((c) => { c.hidden = true; });
    matches.slice(0, limit).forEach((c) => { c.hidden = false; });
    if (more) more.hidden = matches.length <= limit;
  };
  $$('[data-lp-rw-filter]', root).forEach((b) => b.addEventListener('click', () => {
    filter = b.dataset.lpRwFilter;
    limit = initial;
    $$('[data-lp-rw-filter]', root).forEach((x) => { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', String(x === b)); });
    apply();
  }));
  if (more) more.addEventListener('click', () => { limit += initial; apply(); });
  apply();
}

/* ---------- reveal on scroll (sections below the fold only) ---------- */
function initReveal(scope) {
  if (!document.documentElement.classList.contains('lp-anim') || reduceMotion || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) return;
  const io = new IntersectionObserver((entries) => {
    entries.forEach((en) => {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  $$('.lp-sec', scope).forEach((sec) => {
    if (sec.getBoundingClientRect().top > window.innerHeight) {
      sec.classList.add('lp-reveal');
      io.observe(sec);
    }
  });
}
$$('[data-lp-rw]').forEach(initReviewWall);
initReveal(document);
document.addEventListener('shopify:section:load', (e) => { $$('[data-lp-rw]', e.target).forEach(initReviewWall); });
